import { CloseIcon } from "./i/close";

/**
 * 削除可能チップ atom（Figma 5354-11903 Chip）。
 * × ボタンのみ操作可能で、チップ自体は非インタラクティブ。
 * タップ当たり判定を視覚サイズより広く確保（視覚 min-h-[32px] に対し当たり判定 h-[40px]）。
 */
export function FilterChip({
  label,
  onRemove,
}: {
  label: string;
  onRemove: () => void;
}) {
  return (
    <div className="flex h-[40px] items-center py-[4px]">
      <div className="bg-dx-surface-subtle flex min-h-[32px] items-center rounded-full pl-[12px]">
        <span className="font-notojp text-dx-text-default pr-[12px] text-[16px] leading-[28px] whitespace-nowrap">
          {label}
        </span>
        <button
          data-analytics-id="room_type_browse_dismissed_filter"
          type="button"
          onClick={onRemove}
          aria-label={`${label}を削除`}
          className="focus-visible:ring-dx-border-focus flex size-[32px] shrink-0 items-center justify-center rounded-full focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-none"
        >
          <CloseIcon className="size-[20px]" />
        </button>
      </div>
    </div>
  );
}
